import mixpanel from "mixpanel-browser"

export enum Events {
  VisitedHome = "Visited Home",
  VisitedProfile = "Visited Profile",
  SignedUp = "Signed Up",
  ClickedUserPreviewOnExplore = "Clicked User Preview on Explore Page",
  ClickedUserPreviewOnTag = "Clicked User Preview on Tag Page",
  ClickedUserSearchResult = "Clicked User in Search Bar",
  VisitedOpenQuestion = "Visited Open Question",
  VisitedExpiredQuestion = "Visited Expired Question",
  VisitedFlaggedQuestion = "Visited Flagged Question",
  VisitedAnsweredQuestion = "Visited Answered Question",
  ClickedAnswerQuestion = "Clicked Answer Question",
  VisitedEditProfile = "Visted Edit Profile",
  ClickedAskAQuestionCta = "Clicked Ask A Question",
  StartedQuestionBodyInput = "Started Question Body",
  SubmittedQuestionBodyInput = "Submitted Question Body",
  SubmittedCreateQuestionWithPayment = "Created Paid Question",
  VisitedRecordingReady = "Visited Recording Ready Av Check",
  VisitedRecordingPreview = "Visited Recording Preview",
  StartedAnswerRecording = "Started Answer Recording",
  PausedAnswerRecording = "Paused Answer Recording",
  DeletedAnswerRecording = "Deleted Answer Recording",
  SubmittedAnswerRecording = "Submitted Answer Recording",
  AnswerUploaded = "Answer Uploaded",
  ClickedProfileShare = "Clicked Profile Share",
  ClickedAnswerShare = "Clicked Answer Share",
  ClickedQuestionShare = "Clicked Question Share",
  ClickedAnswerCardShare = "Clicked Answer Card Share",
  ClickedQuestionCardShare = "Clicked Question Card Share",
  SetQuestionPrice = "Set Question Price",
  DisabledQuestions = "Disabled Questions",
  ConnectedWallet = "Connected Wallet",
  RequestedTokenMint = "Requested Token Mint",
  RedeemedToken = "Redeemed Token",
  VisitedAnswerPublishing = "Visited Answer Publishing",
  VisitedAnswerProcessing = "Visited Answer Processing",
  VisitedSymphonic = "Visited Symphonic Page",
  VisitedDiscmakers = "Visited Discmakers Page",
}

export const registerEvent = (event: Events) => {
  try {
    if (typeof window !== "undefined" && typeof navigator !== "undefined") {
      mixpanel.track(event)
    }
  } catch (e) {
    //
  }
}
